import { render, staticRenderFns } from "./ListItemCate.vue?vue&type=template&id=1fe153fc&scoped=true"
import script from "./ListItemCate.vue?vue&type=script&lang=js"
export * from "./ListItemCate.vue?vue&type=script&lang=js"
import style0 from "./ListItemCate.vue?vue&type=style&index=0&id=1fe153fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe153fc",
  null
  
)

export default component.exports